// @flow
export const SAVE_UPCOMING_APPOINTMENTS: string = 'SAVE_UPCOMING_APPOINTMENTS';
export const CLEAR_UPCOMING_APPOINTMENTS: string = 'CLEAR_UPCOMING_APPOINTMENTS';
